module.exports = __webpack_public_path__ + "img/20241021141605.f0d4d58d.png";